var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c("div", [
        _c("div", { staticClass: "caseStudiesWrapwx" }, [
          false
            ? _c("div", { staticClass: "caseStudiesTypesWrap" }, [
                _c(
                  "div",
                  { staticClass: "caseStudiesTypes" },
                  _vm._l(_vm.types, function(type, key) {
                    return _c(
                      "div",
                      {
                        staticClass: "caseStudiesType",
                        class: _vm.selected_type == key ? "active" : "",
                        on: {
                          click: function($event) {
                            return _vm.changeType(key)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(type) +
                            "s\n                "
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selected_type == "product"
            ? _c("div", { staticClass: "caseStudiesCategoriesWrap" }, [
                _c(
                  "div",
                  { staticClass: "caseStudiesCategories" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "caseStudiesCategory",
                        class: _vm.selected_category == null ? "active" : "",
                        on: {
                          click: function($event) {
                            return _vm.changeCategory(null)
                          }
                        }
                      },
                      [_c("span", [_vm._v("All")])]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.categories, function(category, key) {
                      return _c(
                        "div",
                        {
                          staticClass: "caseStudiesCategory",
                          class: _vm.selected_category == key ? "active" : "",
                          on: {
                            click: function($event) {
                              return _vm.changeCategory(key)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(category))])]
                      )
                    })
                  ],
                  2
                )
              ])
            : _c("div", { staticClass: "caseStudiesCategoriesWrap" }, [
                _c(
                  "div",
                  { staticClass: "caseStudiesCategories" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "caseStudiesCategory",
                        class: _vm.selected_solution == null ? "active" : "",
                        on: {
                          click: function($event) {
                            return _vm.changeSolution(null)
                          }
                        }
                      },
                      [_c("span", [_vm._v("All")])]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.solutions, function(solution, key) {
                      return _c(
                        "div",
                        {
                          staticClass: "caseStudiesCategory",
                          class: _vm.selected_solution == key ? "active" : "",
                          on: {
                            click: function($event) {
                              return _vm.changeSolution(key)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(solution))])]
                      )
                    })
                  ],
                  2
                )
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "caseStudiesMobile" }, [
            _c("div", { staticClass: "selectWrap" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selected_category,
                      expression: "selected_category"
                    }
                  ],
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selected_category = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      function($event) {
                        return _vm.changeCategory(_vm.selected_category)
                      }
                    ]
                  }
                },
                [
                  _c("option", { domProps: { value: null } }, [_vm._v("All")]),
                  _vm._v(" "),
                  _vm._l(_vm.categories, function(category, key) {
                    return _c("option", { domProps: { value: key } }, [
                      _vm._v(_vm._s(category))
                    ])
                  })
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "caseStudiesBody swiperLight" }, [
            _vm.loading
              ? _c("div", { staticClass: "loader" }, [
                  _c("i", { staticClass: "fas fa-circle-notch fa-spin" })
                ])
              : _vm.case_studies.length > 0
              ? _c(
                  "div",
                  { staticClass: "slideGrid" },
                  _vm._l(_vm.case_studies, function(case_study) {
                    return _c(
                      "a",
                      {
                        staticClass: "gridItem",
                        attrs: { href: case_study.url }
                      },
                      [
                        case_study.fields.grid_image.sizes &&
                        case_study.fields.grid_image.sizes["grid-image"]
                          ? _c("div", {
                              staticClass: "itemImage",
                              style: {
                                backgroundImage:
                                  "url(" +
                                  case_study.fields.grid_image.sizes[
                                    "grid-image"
                                  ] +
                                  ")"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "itemMain" }, [
                          _c("div", { staticClass: "itemMainInner" }, [
                            _c("h3", [
                              _vm._v(_vm._s(case_study.data.post_title))
                            ]),
                            _vm._v(" "),
                            _c("p", [_vm._v("More")])
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "noCaseStudies" }, [
                  _vm._v(
                    "\n                No case studies found\n            "
                  )
                ])
          ])
        ])
      ])
    : _c("div", { staticClass: "loader" }, [
        _c("i", { staticClass: "fas fa-circle-notch fa-spin" })
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }